<template>
  <section class="card card-body">
    <h4>Operação de vendas e leilões</h4>
    <p>Venda direta depende do aval do vendedor. Leilões automáticos usam o maior lance e prorrogam 2 minutos nos lances finais. Apuração automática em até 1 minuto após o prazo.</p>
    <label>Modalidade
      <select v-model="mode" class="form-control" @change="load(1)">
        <option value="">Todas</option><option value="direct">Venda direta</option><option value="proposal">Propostas</option><option value="auction">Leilão</option>
      </select>
    </label>
    <p v-if="error" class="text-danger" role="alert">{{ error }}</p>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead><tr><th>Lote</th><th>Vendedor</th><th>Modalidade</th><th>Situação</th><th>Lances</th><th>Valor</th><th>Encerramento</th><th>Prorrogações</th><th>Comprador reservado / vencedor</th><th>Ação</th></tr></thead>
        <tbody><tr v-for="lot in rows" :key="lot.uuid">
          <td>{{lot.title}}</td><td>{{lot.seller}}</td><td>{{labels[lot.commercial_mode]}}</td>
          <td>{{lot.can_close ? 'Aguardando apuração' : lot.closure_result === 'no_bids' ? 'Encerrado sem lances' : lot.status_text}}</td>
          <td>{{lot.bids_count}}</td><td>{{money(lot.current_bid)}}</td><td>{{date(lot.end_date)}}</td><td>{{lot.auction_extensions}}</td><td>{{lot.winner || '—'}}</td>
          <td><button v-if="lot.can_close" class="btn btn-primary btn-sm" :disabled="busy" @click="close(lot)">Apurar agora</button></td>
        </tr></tbody>
      </table>
    </div>
    <div><button class="btn btn-light" :disabled="page<=1||busy" @click="load(page-1)">Anterior</button> {{page}} / {{last}}
      <button class="btn btn-light" :disabled="page>=last||busy" @click="load(page+1)">Próxima</button>
      <button class="btn btn-outline-primary ml-2" :disabled="busy" @click="load(page)">Atualizar</button>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
export default {
  data:()=>({rows:[],mode:'',page:1,last:1,error:'',busy:false,timer:null,labels:{direct:'Venda direta',proposal:'Propostas',auction:'Leilão'}}),
  mounted(){this.load(1);this.timer=setInterval(()=>{if(!document.hidden)this.load(this.page);},10000);},
  beforeDestroy(){clearInterval(this.timer);},
  methods:{
    headers(){const user=JSON.parse(localStorage.getItem('user')||'{}');return {Accept:'application/json',Authorization:`Bearer ${user.access_token}`};},
    money(v){return Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});},
    date(v){return v?new Date(v).toLocaleString('pt-BR'):'—';},
    async load(page){if(this.busy)return;this.busy=true;try{const {data}=await axios.get(`${process.env.VUE_APP_API}api/v1/admin/auction-operations`,{headers:this.headers(),params:{mode:this.mode,page}});this.rows=data.data.data;this.page=data.data.current_page;this.last=data.data.last_page;this.error='';}catch(e){this.error='Não foi possível atualizar o painel.';}finally{this.busy=false;}},
    async close(lot){if(this.busy)return;this.busy=true;try{await axios.post(`${process.env.VUE_APP_API}api/v1/admin/auction-operations/${lot.uuid}/close`,{},{headers:this.headers()});this.error='';}catch(e){this.error=e.response?.data?.message||'Apuração não concluída.';}finally{this.busy=false;}await this.load(this.page);}
  }
};
</script>
